export default function ProcessingCircleIcon() {
  return (
    <>
      <circle cx='40' cy='40' r='35' fill='url(#paint0_linear_3662_179296)' />
      <path
        d='M40 73.3337C58.4095 73.3337 73.3334 58.4098 73.3334 40.0003C73.3334 21.5908 58.4095 6.66699 40 6.66699C21.5905 6.66699 6.66669 21.5908 6.66669 40.0003C6.66669 58.4098 21.5905 73.3337 40 73.3337Z'
        fill='#FBF3F2'
      />
      <path
        d='M35.0157 40.531C35.0157 39.1674 33.8929 38.062 32.5079 38.062C31.1228 38.062 30 39.1674 30 40.531C30 41.8946 31.1228 43 32.5079 43C33.8929 43 35.0157 41.8946 35.0157 40.531Z'
        fill='#A0383F'
      />
      <path
        d='M34.3888 40.5311C34.3888 39.5084 33.5467 38.6793 32.5079 38.6793C31.4691 38.6793 30.627 39.5084 30.627 40.5311C30.627 41.5538 31.4691 42.3828 32.5079 42.3828C33.5467 42.3828 34.3888 41.5538 34.3888 40.5311Z'
        fill='#A0383F'
        stroke='#A0383F'
      />
      <path
        d='M42.5394 40.531C42.5394 39.1674 41.4166 38.062 40.0315 38.062C38.6464 38.062 37.5236 39.1674 37.5236 40.531C37.5236 41.8946 38.6464 43 40.0315 43C41.4166 43 42.5394 41.8946 42.5394 40.531Z'
        fill='#A0383F'
      />
      <path
        d='M41.9126 40.5311C41.9126 39.5084 41.0705 38.6793 40.0317 38.6793C38.9929 38.6793 38.1508 39.5084 38.1508 40.5311C38.1508 41.5538 38.9929 42.3828 40.0317 42.3828C41.0705 42.3828 41.9126 41.5538 41.9126 40.5311Z'
        fill='#A0383F'
        stroke='#A0383F'
      />
      <path
        d='M50.0634 40.531C50.0634 39.1674 48.9405 38.062 47.5555 38.062C46.1704 38.062 45.0476 39.1674 45.0476 40.531C45.0476 41.8946 46.1704 43 47.5555 43C48.9405 43 50.0634 41.8946 50.0634 40.531Z'
        fill='#A0383F'
      />
      <path
        d='M49.4364 40.5311C49.4364 39.5084 48.5943 38.6793 47.5555 38.6793C46.5167 38.6793 45.6746 39.5084 45.6746 40.5311C45.6746 41.5538 46.5167 42.3828 47.5555 42.3828C48.5943 42.3828 49.4364 41.5538 49.4364 40.5311Z'
        fill='#A0383F'
        stroke='#A0383F'
      />
      <defs>
        <linearGradient
          id='paint0_linear_3662_179296'
          x1='40.6076'
          y1='4.0625'
          x2='39.0387'
          y2='72.7124'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#FBF3F2' />
          <stop offset='1' stopColor='#FFEBE7' stopOpacity='0' />
        </linearGradient>
      </defs>
    </>
  );
}
